import type { TFunction } from "i18next";

/**
 * Plitka izohlarining sof funksiyalari (Q4 skalyarlari).
 *
 * ⚠️⚠️ **`?? 0` BU FAYLDA HAM, CHAQIRUVCHIDA HAM YOZILMAYDI.**
 * `attendance_days.late_minutes` va `early_minutes` `integer NOT NULL
 * DEFAULT 0`, shuning uchun o'rtacha `FILTER (WHERE … > 0)` bilan
 * olinadi va bo'sh to'plamda `NULL` keladi. `null` va `0` — IKKI
 * BOSHQA holat: `avgLateMin ?? 0` yozilsa plitka «O'rtacha 0 daq» deb
 * YOLG'ON gapirardi va bu HECH QANDAY testni qizil qilmasdi.
 *
 * ⚠️ Izohlar shu yerda quriladi, satr ichida (`hint={\`…\`}`) EMAS —
 * aks holda `null` qoidasi uch joyda takrorlanib, bir joyda unutilardi.
 *
 * ⚠️ P7 i18n: hammasi `t` PARAMETR oladi (`modules/audit/utils/actions.ts`
 * ning `amalNomi(action, t)` naqshi) — chaqiruvchi
 * `useTranslation("dashboard")`dan olingan `t`ni uzatadi.
 */

/** ⚠️ `null` — «hodisa yo'q», `0` EMAS. */
export function daqiqaMatn(daq: number | null, t: TFunction): string {
	return daq === null ? t("minutes.dash") : t("minutes.value", { value: Math.round(daq) });
}

/**
 * «Kechikkan» plitkasining izohi.
 *
 * ⚠️⚠️ **Bo'sh holat `kechikkan` SANOG'IDAN aniqlanadi, `avg === null`
 * dan EMAS.** Teskarisi qilinsa plitka «Kechikkan 34» yozib turib
 * ostida «Bugun kechikish yo'q» ko'rsatishi mumkin edi — B tomondagi
 * predikat drifti JIMGINA yashirinardi.
 */
export function kechikishIzohi(
	kechikkan: number,
	avg: number | null,
	max: number | null,
	t: TFunction
): string {
	if (kechikkan === 0) {
		return t("lateHint.none");
	}

	return t("lateHint.value", { avg: daqiqaMatn(avg, t), max: daqiqaMatn(max, t) });
}

/** ⚠️ Bo'sh holat `ertaKetgan` dan — `kechikishIzohi` bilan AYNI qoida. */
export function ertaIzohi(ertaKetgan: number, avg: number | null, t: TFunction): string {
	if (ertaKetgan === 0) {
		return t("earlyHint.none");
	}

	return t("earlyHint.value", { avg: daqiqaMatn(avg, t) });
}

/**
 * «Kelmagan» plitkasining izohi.
 *
 * ⚠️⚠️ **`Math.min(uzrsiz, kelmagan)` YOZILMAYDI.** Qirqish B ning
 * `NOT EXISTS` predikati kogortadan chiqib ketgan holatni UI da
 * normal ko'rsatardi. Qirqilmagan holda «Kelmagan 25 · Shundan 30 tasi
 * uzrsiz» ko'zga tashlanadi va bu KERAK.
 */
export function uzrsizIzohi(kelmagan: number, uzrsiz: number, t: TFunction): string {
	if (kelmagan === 0) {
		return t("absentHint.none");
	}

	return t("absentHint.value", { value: uzrsiz });
}
